import Vue from 'vue'
import Router from 'vue-router'

import Full from '@/containers/Full'
import Header from '@/containers/Header'

// Views
import DashboardView from '@/views/DashboardView'
import OrdersView from '@/views/OrdersView'
import OrderDetailsView from '@/views/OrderDetailsView'
import NewProductView from '@/views/NewProductView'
import ActivableProductsView from '@/views/ActivableProductsView'
import ProductDetailView from '@/views/ProductDetailView'
import Login from '@/views/Pages/Login'
import Page401 from '@/views/Pages/Page401'
import Page404 from '@/views/Pages/Page404'
import Page500 from '@/views/Pages/Page500'
import PunishmentComponentView from '@/views/PunishmentComponentView'
import LiquidationsComponentView from '@/views/LiquidationsComponentView'
import AddMasiveProductsComponentView from '@/views/AddMasiveProductsComponentView'
import ChangePricesByCSVView from '@/views/ChangePricesByCSVView'
import InventoryView from '@/views/InventoryView'
import ReportsView from '@/views/ReportsView'
import IncidentsView from '@/views/incidents/IncidentsView'
import UserAdminView from '@/views/UserAdminView'
import ProfileView from '@/views/ProfileView'
import OrganizationsView from '@/views/OrganizationsView'
import CarriersView from '@/views/CarriersView'
import ShippingGratesView from '@/views/ShippingGratesView'
import AddPricesCSVView from '@/views/AddPricesCSVView'
import CategoryAndBrandUpdaterView from '@/views/CategoryAndBrandUpdaterView'
import CatalogingUpdaterView from '@/views/CatalogingUpdaterView'
import AttributesUpdaterView from '@/views/AttributesUpdaterView'
import PromoList from '@/components/promotion/PromoList'
import IntegrationsView from '@/views/IntegrationsView'
import TaxesView from '@/views/TaxesView'
import SkuDetailView from '@/views/SkuDetailView'
import Substatus from '@/views/Substatus'
import UserView from '@/views/UserView'
import PickupPointsView from '@/views/PickupPointsView'
import PickupPointDetailView from '@/views/PickupPointDetailView'
import {store} from '@/store/store.js'

Vue.use(Router)

export const router = new Router({
  /* mode: 'history', */
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/pages',
      redirect: '/pages/login',
      name: 'Pages',
      component: {
        render (c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: '401',
          name: 'No Autorizado',
          component: Page401
        }
      ]
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: DashboardView
        }
      ]
    },
    {
      path: '/orders',
      redirect: 'orders/list',
      name: 'Ventas',
      component: Full,
      children: [
        {
          path: 'list',
          name: 'Ordenes',
          component: OrdersView
        },
        {
          path: 'addPunishmentCSV',
          name: 'Alta de Penalizaciones por CSV',
          component: PunishmentComponentView
        },
        {
          path: 'addLiquidationsCSV',
          name: 'Alta de Liquidacion por CSV',
          component: LiquidationsComponentView
        },
        {
          path: 'orderDetail/:orderId',
          name: 'Ordenes / Detalle',
          component: OrderDetailsView,
          props: true
        },
        {
          path: 'taxes',
          name: 'Impuestos',
          component: TaxesView
        },
        {
          path: 'substatus',
          name: 'Sub-estados',
          component: Substatus
        }
      ]
    },
    {
      path: '/catalog',
      redirect: '/catalog/list',
      name: 'Catálogo',
      component: Full,
      children: [
        {
          path: 'new',
          name: 'Nuevo producto',
          component: NewProductView
        },
        {
          path: 'promotions',
          name: 'Promociones',
          component: PromoList
        },
        {
          path: 'list',
          name: 'Administrar Productos',
          component: ActivableProductsView
        },
        {
          path: 'details/:productId',
          name: 'Detalle',
          component: ProductDetailView,
          props: true
        },
        {
          path: 'details/:productId/sku',
          name: 'Crear Sku',
          component: SkuDetailView,
          props: true
        },
        {
          path: 'details/:productId/sku/:skuId',
          name: 'Detalle Sku',
          component: SkuDetailView,
          props: true
        },
        {
          path: 'addProductsCSV',
          name: 'Alta masiva de productos',
          component: AddMasiveProductsComponentView
        },
        {
          path: 'changePricesCSV',
          name: 'Editar precios por CSV',
          component: ChangePricesByCSVView
        },
        {
          path: 'inventory/list',
          name: 'Inventario',
          component: InventoryView
        }
      ]
    },
    {
      path: '/carriers',
      redirect: '/carriers/carrierList',
      name: 'Gestión de envíos',
      component: Full,
      children: [
        {
          path: 'carrierList',
          name: 'Transportadoras',
          component: CarriersView
        },
        {
          path: 'pickupPoints',
          name: 'Puntos de retiro',
          component: PickupPointsView
        },
        {
          path: 'pickupPoints/new',
          name: 'Crear Punto de retiro',
          component: PickupPointDetailView
        },
        {
          path: 'pickupPoints/:pickupPointId',
          name: 'Detalle punto de retiro',
          component: PickupPointDetailView
        },
        {
          path: 'priceList',
          name: 'Precios',
          component: ShippingGratesView
        },
        {
          path: 'addPricesCSV',
          name: 'Alta masiva de Precios de Transportadoras',
          component: AddPricesCSVView
        }
      ]
    },
    {
      path: '/incidents',
      redirect: '/incidents/list',
      name: 'Incidencias',
      component: Full,
      children: [
        {
          path: 'list',
          name: 'Manejo de incidencias',
          component: IncidentsView
        }
      ]
    },
    {
      path: '/reports',
      redirect: '/reports/list',
      name: 'Reportes',
      component: Full,
      children: [
        {
          path: 'list',
          name: 'Ver Reportes',
          component: ReportsView
        }
      ]
    },
    {
      path: '/admin',
      redirect: '/admin/users',
      name: 'Administración',
      component: Full,
      children: [
        {
          path: 'users',
          name: 'Usuarios',
          component: UserAdminView
        },
        {
          path: 'user',
          name: 'Crear Usuario',
          component: UserView
        },
        {
          path: 'user/:id',
          name: 'Editar Usuario',
          component: UserView
        },
        {
          path: 'sellers',
          name: 'Sellers',
          component: OrganizationsView
        },
        {
          path: 'integrations',
          name: 'Integraciones',
          component: IntegrationsView
        }
      ]
    },
    {
      path: '/profile',
      redirect: '/profile/me',
      name: 'Perfil',
      component: Full,
      children: [
        {
          path: 'me',
          name: 'Usuario',
          component: ProfileView
        }
      ]
    },
    {
      path: '/updates',
      name: 'Actualizaciones',
      redirect: '/updates/catalogAndBrand',
      component: Full,
      children: [
        {
          path: 'catalogAndBrand',
          name: 'Categorias y Marcas',
          component: CategoryAndBrandUpdaterView
        },
        {
          path: 'attributes',
          name: 'Atributos',
          component: AttributesUpdaterView
        },
        {
          path: 'cataloging',
          name: 'Catálogo Siman',
          component: CatalogingUpdaterView
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Header,
      redirect: 'pages/404',
      children: [
        {
          path: 'pages/404',
          name: 'Page404',
          component: Page404
        }
      ]
    }

  ]
})

router.beforeEach((to, from, next) => {
  if (to && to.name === 'Ordenes' && from && from.name !== 'Ordenes / Detalle') {
    store.dispatch('setOrderFilter', null)
  }

  let isAdmin = false
  if (sessionStorage.getItem('vue-session-key') === null) {
    sessionStorage.setItem('vue-session-key', '{}')
  }

  if(JSON.parse(sessionStorage.getItem('vue-session-key')).userData){
    let hasRole = JSON.parse(sessionStorage.getItem('vue-session-key')).userData.roles.find((role) => {
        return role.roleName === 'ADMIN_USER' || role.roleName === 'STANDARD_USER'
      }
    )
    isAdmin = (hasRole) ? true : false
  }

  if (to.name !== 'Login' && (sessionStorage.getItem('vue-session-key') === null || sessionStorage.getItem('vue-session-key') === '{}')
    || to.meta.authRequired === 'true' && !isAdmin) {
        if (to.meta.authRequired === 'true' && !isAdmin) {
          next('/pages/401')
        } else {
          next('/pages/login')
        }
  } else {
    next()
  }
})
